import { toast } from "@/hooks/use-toast";
import { CheckCircle2, AlertCircle, Info, X } from "lucide-react";
import { createElement } from "react";

interface ToastOptions {
  title: string;
  description?: string;
  duration?: number;
}

// 내부 구현 함수들
const showSuccess = ({ title, description, duration = 5000 }: ToastOptions) => {
    toast({
      title: createElement("div", {
        className: "flex items-center gap-2",
        children: [
          createElement(CheckCircle2, { key: "icon", className: "h-4 w-4 text-success-600" }),
          createElement("span", { key: "text" }, title),
        ],
      }),
      description,
      variant: "success", // success variant 사용
      duration,
    });
};

const showError = ({ title, description, duration = 5000 }: ToastOptions) => {
    toast({
      title: createElement("div", {
        className: "flex items-center gap-2",
        children: [
          createElement(AlertCircle, { key: "icon", className: "h-4 w-4 text-destructive-600" }),
          createElement("span", { key: "text" }, title),
        ],
      }),
      description,
      variant: "destructive",
      duration,
    });
};

const showInfo = ({ title, description, duration = 5000 }: ToastOptions) => {
    toast({
      title: createElement("div", {
        className: "flex items-center gap-2",
        children: [
          createElement(Info, { key: "icon", className: "h-4 w-4 text-accent-600" }),
          createElement("span", { key: "text" }, title),
        ],
      }),
      description,
      duration,
    });
};

const showWarning = ({ title, description, duration = 5000 }: ToastOptions) => {
    toast({
      title: createElement("div", {
        className: "flex items-center gap-2",
        children: [
          createElement(AlertCircle, { key: "icon", className: "h-4 w-4 text-warning-600" }),
          createElement("span", { key: "text" }, title),
        ],
      }),
      description,
      duration,
    });
};

// 간편 래퍼 함수들
const success = (titleOrOptions: string | ToastOptions, description?: string) => {
  if (typeof titleOrOptions === 'string') {
    return showSuccess({ title: titleOrOptions, description });
  }
  return showSuccess(titleOrOptions);
};

const error = (titleOrOptions: string | ToastOptions, description?: string) => {
  if (typeof titleOrOptions === 'string') {
    return showError({ title: titleOrOptions, description });
  }
  return showError(titleOrOptions);
};

const info = (titleOrOptions: string | ToastOptions, description?: string) => {
  if (typeof titleOrOptions === 'string') {
    return showInfo({ title: titleOrOptions, description });
  }
  return showInfo(titleOrOptions);
};

const warning = (titleOrOptions: string | ToastOptions, description?: string) => {
  if (typeof titleOrOptions === 'string') {
    return showWarning({ title: titleOrOptions, description });
  }
  return showWarning(titleOrOptions);
};

// 외부 API
export const toastUtils = {
  success,
  error,
  info,
  warning,
};